import React, { useState, useEffect } from 'react';
import { formatLocale } from './tzUtil';
import { isMuto, setMuto, suonaAvviso } from './suono';
import './promemoria.css';

export default function PromemoriaAlert({ promemoria, restanti, onPosticipa, onElimina, onFatto }) {
  const [conferma, setConferma] = useState(false);
  const [muto, setMutoState] = useState(isMuto());
  useEffect(() => { setConferma(false); }, [promemoria.id]);

  return (
    <div className="prom-backdrop">
      <div className="prom-modal">
        <h3>🔔 {promemoria.titolo}</h3>
        {promemoria.note && <p className="prom-note">{promemoria.note}</p>}
        {promemoria.clienteNome && <p className="prom-cliente">Cliente: {promemoria.clienteNome}</p>}
        <small className="prom-data">
          Previsto per {formatLocale(promemoria.dataOra)}
          {promemoria.destinatarioTipo && promemoria.destinatarioTipo !== 'tutti' && (
            <span className="prom-badge">{promemoria.destinatarioLabel}</span>
          )}
        </small>

        {!conferma ? (
          <div className="prom-azioni prom-col">
            <button className="prom-btn prom-ok" onClick={onFatto}>✓ Fatto</button>
            <div style={{display:'flex',gap:10}}>
              <button className="prom-btn" onClick={onPosticipa}>Posticipa 1 ora</button>
              <button className="prom-btn prom-danger" onClick={() => setConferma(true)}>Elimina</button>
            </div>
          </div>
        ) : (
          <div className="prom-azioni prom-col">
            <span className="prom-domanda">Eliminare il promemoria per chi?</span>
            <button className="prom-btn" onClick={() => onElimina('me')}>Solo per me</button>
            <button className="prom-btn prom-danger" onClick={() => onElimina('tutti')}>Per tutti</button>
            <button className="prom-btn prom-ghost" onClick={() => setConferma(false)}>Annulla</button>
          </div>
        )}

        {restanti > 0 && <small className="prom-restanti">Altri {restanti} promemoria in attesa</small>}

        <div style={{ marginTop:10, textAlign:'center' }}>
          <button
            onClick={() => { const v = !muto; setMuto(v); setMutoState(v); if (!v) suonaAvviso(); }}
            style={{ background:'none', border:'none', color:'#888',
                     fontSize:12, cursor:'pointer' }}>
            {muto ? '🔇 Suono disattivato — riattiva' : '🔊 Suono attivo — disattiva'}
          </button>
        </div>
      </div>
    </div>
  );
}
